import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";

function Footer() {
  const [email, setEmail] = useState("");

  async function SendMail(email) {
    let encodedEmail = btoa(email);
    console.log(encodedEmail);
    const { status, data } = await axios.get(
      `https://irfanwrites.herokuapp.com/subs/${email}`
    );
    if (!data.canJoin) {
      return alert("You are already a Subscriber!!");
    } else {
      if (email !== "" && email.includes("@")) {
        const { status, data } = await axios.post(
          "https://webstarkmail.herokuapp.com/api/email/send",
          {
            email: email,
            subject: "Subscription | IrfanWrites",
            data:
              "Dear subscriber , <br> <br> You are just one step away from subscription!! Click the link below and start an amazing journey with us!<br>",
            userlink: `https://irfanwrites.herokuapp.com/subscribe/${encodedEmail}`,
            ref: "Irfan Writes App",
            api_key: "8qbr96cw",
          }
        );
        if (status === 200) {
          console.log(data);
          if (data.message) {
            alert(data.message);
          }
        }
      }
    }
  }

  return (
    <div>
      <div
        class='modal fade'
        id='exampleModal'
        tabindex='-1'
        aria-labelledby='exampleModalLabel'
        aria-hidden='true'
      >
        <div class='modal-dialog'>
          <div class='modal-content'>
            <div class='modal-header'>
              <h5 class='modal-title' id='exampleModalLabel'>
                Congratulations 😍
              </h5>
              <button
                type='button'
                class='btn-close'
                data-mdb-dismiss='modal'
                aria-label='Close'
              ></button>
            </div>
            <div class='modal-body'>
              We've sent you a confirmarion email. Kindly, Confirm to start
              recieving awesome content!!
              <br />
              <br />
              Thanks for Joining!!
            </div>
            <div class='modal-footer'>
              <button
                type='button'
                class='btn btn-secondary'
                data-mdb-dismiss='modal'
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <footer class='bg-light text-center mt-5 pt-5'>
        <div class='container p-4'>
          <section class='mb-4'>
            <a
              class='btn btn-primary btn-floating m-1'
              style={{ backgroundColor: "#ac2bac" }}
              href='https://instagram.com/the.loudsilence'
              role='button'
            >
              <i class='fab fa-instagram'></i>
            </a>

            <a
              class='btn btn-primary btn-floating m-1'
              style={{ backgroundColor: "#0082ca" }}
              href='https://linkedin.com/in/irfan-ukani'
              role='button'
            >
              <i class='fab fa-linkedin-in'></i>
            </a>

            <a
              class='btn btn-primary btn-floating m-1'
              style={{ backgroundColor: "#333333" }}
              href='https://github.com/irfanukani'
              role='button'
            >
              <i class='fab fa-github'></i>
            </a>
          </section>

          <section class=''>
            <div class='row d-flex justify-content-center'>
              <div class='col-auto'>
                <p class='pt-2'>
                  <strong>Sign up for our newsletter</strong>
                </p>
              </div>

              <div class='col-md-5 col-12'>
                <div class='  mb-4'>
                  <input
                    type='email'
                    id='form5Example2'
                    class='form-control'
                    value={email}
                    placeholder='Email Here...'
                    onChange={(e) => {
                      setEmail(e.target.value);
                     
                    }}
                  />
                </div>
              </div>

              <div class='col-auto'>
                <button
                  type='submit'
                  class='btn btn-primary mb-4'
                  data-mdb-toggle={
                    email !== "" && email.includes("@") ? "modal" : ""
                  }
                  data-mdb-target={
                    email !== "" && email.includes("@") ? "#exampleModal" : ""
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    SendMail(email);
                    setTimeout(() => {
                      setEmail("");
                    }, 2000);
                  }}
                >
                  Subscribe
                </button>
              </div>
            </div>
          </section>
        </div>
        <div
          class='text-center p-3 text-light fw-lighter'
          style={{ backgroundColor: "rgb(0, 0, 0)" }}
        >
          © 2021 Copyright &nbsp;: &nbsp;
          <Link class='text-primary' to='/'>
            IrfanWrites.web.app
          </Link>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
